import { Button } from "@carbon/react";

import { Select, TextInput } from "../../../ui";
import { SectionHeader } from "../../../components";

export const View = (props) => {
  return (
    <div className="onboarding-section">
      <SectionHeader
        title="Secure your account."
        subtitle="SwitchApp helps its users secure their account, using either your phone, email or an authenticator app, in addition to your password, it ensure you that no one else can log in to your account, or make any transactions."
      />

      <h5 className="form-section--title font-ctm--bold">
        Two-Step Authentication
      </h5>

      <TextInput disabled={!props.isActive} />

      <TextInput disabled={!props.isActive} />

      <Select disabled={!props.isActive} />

      <Select disabled={!props.isActive} />

      <Select disabled={!props.isActive} />

      
        

        {!props.isActive ? null : (
          <Button
            className="switchapp-themed onboarding-submit--button new button"
            onClick={props.onSubmit}
          >
            Continue
          </Button>
        )}
      </div>
   
  );
};
